module.exports = __webpack_public_path__ + "media/images/calendar/august-681392f06cb31dc1a36067b5d10c9d8f.jpg";